import { gql } from "@apollo/client";

export const FETCH_SAVED_SEARCHES = gql`
  query FetchSavedSearches($target: String!) {
    me {
      savedSearches(target: $target) {
        id
        clientId
        userId
        target
        name
        searchMethod
        searchOperator
        query
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPSERT_SAVED_SEARCH = gql`
  mutation UpsertSavedSearch(
    $target: String!
    $name: String!
    $searchMethod: SavedSearchMethod!
    $searchOperator: SavedSearchOperator
    $query: String!
  ) {
    upsertSavedSearch(
      target: $target
      name: $name
      searchMethod: $searchMethod
      searchOperator: $searchOperator
      query: $query
    ) {
      id
      clientId
      userId
      target
      name
      searchMethod
      searchOperator
      query
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_SAVED_SEARCH = gql`
  mutation DeleteSavedSearch($id: String!) {
    deleteSavedSearch(id: $id) {
      id
      clientId
      userId
      target
      name
      searchMethod
      searchOperator
      query
      createdAt
      updatedAt
    }
  }
`;
